import type {ExampleData, DataCallbackOptions} from '../../Common';
import {addPerspectiveCameraOBJWithOrbitControls} from '../../ExampleUtils';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();
	const geo = root.createNode('geo');
	const torusKnot = geo.createNode('torusKnot');

	// add a light
	root.createNode('hemisphereLight');

	const {perspectiveCamera1} = addPerspectiveCameraOBJWithOrbitControls(root);

	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [torusKnot],
		autoLayout: true,
	};
}
// export const sopTorusKnot = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/sop/torusKnot`,
// 		createData,
// 		relatedNodes: [TorusKnotSopNode],
// 	}),
// ];
